import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Meta } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { CompanyService } from 'src/services/company/company.service';
import { CryptoService } from 'src/services/crypto/crypto.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-validation-code',
  templateUrl: './validation-code.component.html',
  styleUrls: ['./validation-code.component.scss']
})
export class ValidationCodeComponent implements OnInit {
  form: FormGroup;
  loading: boolean;
  returnUrl: string;

  constructor(
      private fb: FormBuilder,
      private recaptchaV3Service: ReCaptchaV3Service,
      private router: Router,
      private route: ActivatedRoute,
      private companyService: CompanyService,
      private meta: Meta,
      private cryptoService: CryptoService
  ) { }

  ngOnInit(): void {
      this.returnUrl = this.route.snapshot.params.next;
      
      this.meta.addTag({ name: 'description', content: "Validation de code" });
      this.meta.addTag({ name: 'keywords', content: 'BSTP Guinée, BSTP, bstpgn, validation, sécurité' });
      this.meta.addTag({ name: 'author', content: 'BSTP Guinée' });

      this.form = this.fb.group({
          code: this.fb.control(null, [
              Validators.required, 
              Validators.pattern('^[0-9]{6}$'),
              Validators.minLength(6),
              Validators.maxLength(6)
          ]),
          recaptcha: this.fb.control(null, [Validators.required]),
      });

      if (this.companyService.isAuthenticated()) {
        
          const returnUrl = "company/dashboard";

          window.location.replace(returnUrl);
      }
  }

  onSubmit() {
      if (this.form.invalid) {
          for (const control of Object.keys(this.form.controls)) {
              this.form.controls[control].markAsTouched();
          }
          return;
      }

      this.recaptchaV3Service
          .execute("importantAction")
          .subscribe((token: string) => {
              console.debug(`Token [${token}] generated`);
          });

      this.loading = true;
      // Récupérer l'email stocké lors de la connexion
      const email = localStorage.getItem("email");
      
      if (!email) {
          this.loading = false;
          Swal.fire({
              title: "Erreur",
              html: "Session expirée. Veuillez vous reconnecter.",
              icon: "error",
              showCancelButton: false,
              confirmButtonColor: '#006481',
              color: '#006481',
              iconColor: '#e40e20',
              cancelButtonColor: '#d33',
              confirmButtonText: 'FERMER',
          });
          this.router.navigate(['/company-login']);
          return;
      }
      
      // Envoyer le code de validation avec l'email
      this.companyService.checkAuthentication({
          email: email,
          code: this.form.value.code,
          recaptcha: this.form.value.recaptcha
      }).subscribe({
          next: (data: any) => {
              this.loading = false;
              // Stocker le token d'authentification si nécessaire
              const encryptedData = this.cryptoService.encrypt(data);
              localStorage.setItem("company", encryptedData);
              
              // Rediriger vers le tableau de bord ou la page d'accueil
              this.router.navigate(['/company', 'dashboard']);
              
              // Swal.fire({
              //     title: "Succès",
              //     html: "Votre compte a été validé avec succès.",
              //     icon: "success",
              //     showCancelButton: false,
              //     confirmButtonColor: '#00533e',
              //     color: '#00533e',
              //     confirmButtonText: 'CONTINUER',
              // });
          },
          error: (error) => {
              console.error(error);
              this.loading = false;
              Swal.fire({
                  title: "Erreur de validation",
                  html: error.error?.detail || "Code de validation incorrect ou expiré.",
                  icon: "error",
                  showCancelButton: false,
                  confirmButtonColor: '#006481',
                  color: '#006481',
                  iconColor: '#e40e20',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'RÉESSAYER',
              });
          },
      });
  }
}
